import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-question-end",
  "use": "foquz-icon-question-end-usage",
  "viewBox": "0 0 25 20",
  "content": "<symbol viewBox=\"0 0 25 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-question-end\"><path d=\"M12.333 3.222c0-.59.281-1.154.781-1.571C13.614 1.234 14.293 1 15 1h6.333c.708 0 1.386.234 1.886.65.5.418.781.983.781 1.572v13.556c0 .59-.281 1.154-.781 1.571-.5.417-1.178.651-1.886.651H15c-.707 0-1.386-.234-1.886-.65-.5-.418-.78-.983-.78-1.572M8 5l5 5-5 5m4-5H1\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol